function doIndents(str) {
  return `<span>${str.replace(/(?:\r\n|\r|\n)/g, '<br/>')}</span>`;
}

export default {
  bind(el, binding) {
    const $el = el;
    $el.innerHTML = doIndents(binding.value);
  },
  update(el, binding) {
    const $el = el;
    $el.innerHTML = doIndents(binding.value);
  },
};
